export const actionDispatcher = (type, key, payload) => {
  return {
    type,
    [key]: payload,
  };
};
